import React from "react";

import { V2 } from "../../../Api";
import { RouteComponentPropsHistory } from "../../../types";
import { formatDateTimeLocal, formatName } from "../../../Utilities";

import withTitle from "../../withTitle";


interface IPatientDocumentVersionListViewProps extends RouteComponentPropsHistory<any, any> {
}

interface IPatientDocumentVersionListViewState {
    isLoading: boolean | string;
    versions: any[];
}

class PatientDocumentVersionListView extends React.Component<IPatientDocumentVersionListViewProps, IPatientDocumentVersionListViewState> {
    constructor(props: Readonly<IPatientDocumentVersionListViewProps>) {
        super(props);

        const state: IPatientDocumentVersionListViewState = {
            isLoading: true,
            versions: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="">Date &amp; Time</th>
                            <th className="col-smallest">Amended by</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Document versions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isLoading === true
                            ? <tr>
                                <td colSpan={10}><div className="spinner spinner-center lds-dual-ring" /></td>
                            </tr>
                            : typeof this.state.isLoading === "string"
                                ? <tr>
                                    <td colSpan={10} className="error-text">{this.state.isLoading}</td>
                                </tr>
                                : this.state.versions.map(a => <tr key={a.id} className="clickable" onClick={() => this.openDocument(a.id)}>
                                    <td>{formatDateTimeLocal(a.creationTimestamp)}</td>
                                    <td>{formatName(a.creator?.name)}</td>
                                    <td>
                                        {a.lockedBy ? <i className="icon icon-lock" title={`Locked by ${formatName(a.lockedBy.name)}`} /> : null}
                                        {a.isFinalized ? <i className="icon icon-check" title="Finalized" /> : null}
                                    </td>
                                </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const result = await V2.get<any>(`document/${this.props.match.params.documentId}/versions`);

            this.setState({
                isLoading: false,
                versions: result.versions
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load versions"
            });
        }
    }

    private openDocument(id: string) {
        this.props.history.push(`../${id}`);
    }
}

export default withTitle("Previous document versions", PatientDocumentVersionListView);
